import React from "react";
import styled from "styled-components";
import {
  Spacing,
  content,
  form,
  prettyScrollbars,
  transparentize,
} from "@glossy";
import { Locale } from "@linkfluence/models/locale";
import { tr } from "@radarly/i18n";
import {
  ClassificationFilter,
  ClassificationFilters,
} from "@radarly/models/filters";
import SubLevel from "./sublevel";
import { getLevelFilters, getLevelsListFromFilters } from "./utils";

interface IProps {
  classificationFilters: ClassificationFilters;
  onChangeLevel: (level: number, filterId: string) => void;
  onChangeStatus: (
    filter: ClassificationFilter,
    status: string,
    level: number
  ) => void;
  currentLevel: number;
  currentFilter: string;
  locale: Locale;
}

const Root = styled.div`
  display: flex;
  min-height: 205px;
`;

const Level = styled.div`
  flex-basis: ${100 / 3}%;
  display: flex;
  flex-direction: column;
  border-right: 1px solid ${(props) => content(props, "tertiary")};
  &:last-child {
    border: none;
  }
`;

const LevelTitle = styled.div`
  padding: ${Spacing.ExtraSmall} ${Spacing.ExtraSmall} ${Spacing.ExtraSmall}
    ${Spacing.Large};
  color: ${form};
  border-bottom: 1px solid;
  border-color: ${(props) => content(props, "tertiary")};
`;

const LevelFilters = styled.div`
  flex: 1 1 auto;
  overflow-y: auto;
  padding-top: ${Spacing.ExtraSmall};
  ${prettyScrollbars()};
`;

const NoSubFilters = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props) => transparentize(0.5, content(props, "primary"))};
`;

const NoSubFiltersComponent = ({ locale }) => (
  <NoSubFilters>
    {tr(locale, "FILTER::CLASSIFICATION::NO-SUBCATEGORIES")}
  </NoSubFilters>
);

const FilterbarPanelsClassificationLevels = ({
  classificationFilters,
  currentLevel,
  onChangeLevel,
  currentFilter,
  onChangeStatus,
  locale,
}: IProps) => {
  const levelsList = getLevelsListFromFilters(classificationFilters);
  return (
    <Root>
      {levelsList.map((level) => {
        const level2Filters =
          level === 3
            ? getLevelFilters(classificationFilters, currentFilter, 2)
            : [];
        return (
          <Level key={`level_${level}`}>
            <LevelTitle>
              {tr(locale, "FILTER::CLASSIFICATION::LEVEL", { level })}
            </LevelTitle>
            <LevelFilters>
              {level <= currentLevel && (
                <SubLevel
                  filters={classificationFilters}
                  level={level}
                  onChangeLevel={onChangeLevel}
                  onChangeStatus={onChangeStatus}
                  currentFilter={currentFilter}
                >
                  <NoSubFiltersComponent locale={locale} />
                </SubLevel>
              )}
              {level === 3 && level2Filters.length === 0 && currentFilter && (
                <NoSubFiltersComponent locale={locale} />
              )}
            </LevelFilters>
          </Level>
        );
      })}
    </Root>
  );
};

export default FilterbarPanelsClassificationLevels;
